import { useCreateTalentAgencyWithUserMutation } from '@anytag/graphql';
import { UNEXPECTED_ERROR } from '@anytag/shared-constants';
import { useUpdateDocumentTitle, useQueryHelper } from '@anytag/shared-hooks';
import { Header } from '@anytag/shared-molecules';
import { TalentAgencyFormValues, TalentAgencyForm } from '@anytag/shared-organisms';

export const AddTalentAgency = () => {
  useUpdateDocumentTitle({
    title: 'appHeader.Add New Talent Agency',
    appHeader: 'appHeader.Add New Talent Agency',
    href: '/talent-agency'
  });
  const { t, navigate, enqueueSnackbar } = useQueryHelper();
  const { callCreateTalentAgencyWithUser } = useCreateTalentAgencyWithUserMutation();

  const handleSubmit = async ({
    countryId,
    agencyIds,
    companyUrl,
    netsuiteId,
    phoneNumber,
    advertiserIds,
    talentAgencyName,
    ...restProps
  }: TalentAgencyFormValues) => {
    try {
      if (restProps.type === 'add') {
        await callCreateTalentAgencyWithUser({
          variables: {
            input: {
              name: restProps.name,
              email: restProps.email,
              countryId,
              talentAgencyName,
              hasInvitationEmail: restProps.hasInvitationEmail,
              netsuiteId: netsuiteId || null,
              companyUrl: companyUrl || null,
              password: restProps.password || undefined,
              phoneNumber: phoneNumber || null,
              agencyIds: agencyIds.map(Number),
              advertiserIds: advertiserIds.map(Number)
            }
          }
        });
      }
      enqueueSnackbar(t('succeededInCreating', { name: talentAgencyName }), { variant: 'success' });
      navigate({ to: '/talent-agency' });
    } catch (error) {
      enqueueSnackbar(t('failedToCreate', { name: talentAgencyName }), { variant: 'error' });
      enqueueSnackbar(t(error.message || UNEXPECTED_ERROR), { variant: 'error' });
    }
  };

  return (
    <div>
      <Header />

      <TalentAgencyForm onSubmit={handleSubmit} defaultValues={{ type: 'add' }} />
    </div>
  );
};
